import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M7 3.75C6.30964 3.75 5.75 4.30964 5.75 5V19.5C5.75 20.1904 6.30964 20.75 7 20.75H17.5C18.1904 20.75 18.75 20.1904 18.75 19.5V5C18.75 4.30964 18.1904 3.75 17.5 3.75H7ZM4.25 5C4.25 3.48122 5.48122 2.25 7 2.25H17.5C19.0188 2.25 20.25 3.48122 20.25 5V19.5C20.25 21.0188 19.0188 22.25 17.5 22.25H7C5.48122 22.25 4.25 21.0188 4.25 19.5V5ZM12.25 6.75C11.6977 6.75 11.25 7.19772 11.25 7.75C11.25 8.30228 11.6977 8.75 12.25 8.75C12.8023 8.75 13.25 8.30228 13.25 7.75C13.25 7.19772 12.8023 6.75 12.25 6.75ZM9.75 7.75C9.75 6.36929 10.8693 5.25 12.25 5.25C13.6307 5.25 14.75 6.36929 14.75 7.75C14.75 9.13071 13.6307 10.25 12.25 10.25C10.8693 10.25 9.75 9.13071 9.75 7.75ZM10.25 15.75C10.25 14.6454 11.1454 13.75 12.25 13.75C13.3546 13.75 14.25 14.6454 14.25 15.75C14.25 16.8546 13.3546 17.75 12.25 17.75C11.1454 17.75 10.25 16.8546 10.25 15.75ZM12.25 12.25C10.317 12.25 8.75 13.817 8.75 15.75C8.75 17.683 10.317 19.25 12.25 19.25C14.183 19.25 15.75 17.683 15.75 15.75C15.75 13.817 14.183 12.25 12.25 12.25Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const SpeakerOutlined = React.forwardRef(IconComponent);
SpeakerOutlined.displayName = 'SpeakerOutlined';

export { SpeakerOutlined };
